"use strict";

import { Grid, html } from "gridjs";
import moment from "moment";
import utils from "../blocks/_utils";

(function () {
    const tableWrapper = document.getElementById('sent-letters');
    if(! tableWrapper) {
        return
    }

    const tableLettersViewConfig = () => {
        return {
            columns: ["Date", "Subject", "Sent", "Opened"/* {
            name: "Opened",
            formatter(cell, row){
                return html(`<b>${cell}</b>`);
            }
        }*/],
            pagination: {
                enabled: true,
                limit: 10,
                server: {
                    url: (prev, page, limit) => `${prev}?limit=${limit}&offset=${page * limit}`
                }
            },
            /*data: () => {
                return new Promise(resolve => {
                    $.request('lettersList::onGet', {
                        data: {},
                        success(data, status, xhr){
                            resolve(data.map(row => [
                                row.created_at, row.subject,
                                `${row.processed} / ${row.total}`,
                                `${row.views_count} / ${row.total}`
                            ]))
                        }
                    });
                });
            },*/
            server: {
                url: '',
                data: (opts) => {

                    return new Promise(resolve => {
                        let searchParams = new URLSearchParams(opts.url);

                        $.request('lettersList::onGet', {
                            data: {
                                limit: searchParams.get("limit"),
                                offset: searchParams.get("offset")
                            },
                            success(response, status, xhr){
                                resolve({
                                    data: response.data.map(row => {
                                        let percent = 0;
                                        if(row.total > 0){
                                            percent = (row.views_count * 100 / row.total).toFixed(2);
                                        }

                                        const momentJsDateFormat = 'LLL';

                                        let createdField = `${moment(row.created_at).format(momentJsDateFormat)} (UTC)`;

                                        if(row.processed < row.total){
                                            createdField = `🔄 ` + createdField;

                                            if(row.postponed_until){
                                                createdField = `📅 ${moment(row.postponed_until).format(momentJsDateFormat)} (UTC)`;
                                                createdField += '<div class="pt-2">' +
                                                    '<button data-letter="delete"' +
                                                    `data-id="${row.id}" class="btn btn-sm btn-light">Cancel</button></div>`;
                                            }
                                        } else {
                                            createdField = `✅ ` + createdField;
                                        }

                                        return [
                                            html(`${createdField}`), row.subject,
                                            html(`<button class="btn btn-sm btn-light" data-details="view" data-id="${row.id}">${row.processed} / ${row.total}</button>`),
                                            html(`${row.views_count} / ${row.total} <span class="text-muted">${percent}%</span>`)
                                        ]
                                    }),
                                    total: response.total
                                })
                            }
                        });
                    });
                }
            }
        }
    };

    const table = new Grid(tableLettersViewConfig()).render(tableWrapper);

    const tableDetailsViewConfig = (letterId) => {
        return {
            columns: [
                {
                    name: "Contact",
                    formatter(cell){
                        const name = `${cell.first_name} ${cell.last_name}`;
                        if(cell.contact_id){
                            return html(`<a data-id="${cell.contact_id}" data-toggle="modal" data-target="#contactModal" class="btn btn-sm btn-light modal-contact-link" href="#contact-${cell.contact_id}">${name}</a>`);
                        } else {
                            return name;
                        }
                    }},
                "Email", {
                    name: "Sent",
                    formatter(cell) {
                        if(cell){
                            return "✅";
                        }
                        return "⏳";
                    }
                }, {
                name: "Opened"
                    ,formatter(cell) {
                        if(! cell){
                            return "-️";
                        }
                        return cell;
                    }
                }],
            pagination: {
                enabled: true,
                limit: 20,
                server: {
                    url: (prev, page, limit) => `${prev}?limit=${limit}&offset=${page * limit}`
                }
            },
            server: {
                url: '',
                data: (opts) => {

                    return new Promise(resolve => {
                        let searchParams = new URLSearchParams(opts.url);

                        $.request('lettersList::onGetReceivers', {
                            data: {
                                letterId: letterId,
                                limit: searchParams.get("limit"),
                                offset: searchParams.get("offset")
                            },
                            success(response, status, xhr){
                                resolve({
                                    data: response.data.map(row => [
                                        row.vars,
                                        `${row.email}`,
                                        row.sent,
                                        row.opened,
                                    ]),
                                    total: response.total
                                })
                            }
                        });
                    });
                }
            }
        }
    }

    $('#btn-letters-table').on('click', function () {
        table.updateConfig(tableLettersViewConfig()).forceRender();
        $('#btn-letters-table').addClass('d-none')
    })

    $('body').on('click', 'button[data-details="view"]', function () {
        const letterId = $(this).data('id');
        table.updateConfig(tableDetailsViewConfig(letterId)).forceRender();

        $('#btn-letters-table').removeClass('d-none')
    }).on('click', 'button[data-letter="delete"]', function () {
        const letterId = $(this).data('id');

        $.request('lettersList::onDelete', {
            data: {
                id: letterId
            },
            "confirm": utils.i18n('messages.are-you-sure'),
            success(){
                table.forceRender();
            }
        })

    });


    function loadContactToModal(nextId) {
        if(nextId === false){
            nextId = $("#contactModal").data('id');
        }
        $("#contactModal").data('id', nextId);
        $("#contact-modal-wrapper").html('<div class="spinner-border text-secondary" role="status"><span class="sr-only">Loading...</span></div>');
        $.request('viewContact::onRenderModal', {
            flash: true,
            complete: function(){

                $("button[data-toggle=contact]").prop('disabled', false);
                myCustomEventDispatch('entryModalShow', {
                    contact_id: nextId
                });
            },
            handleErrorMessage: function(message) {
                $.oc.flashMsg({ text: message, class: 'error' })
            },
            handleFlashMessage: function(message, type) {
                $.oc.flashMsg({ text: message, class: type })
            },
            data: {
                call: (window['callMode']) ? "true" : "false",
                id: nextId
            }
        })
    }

    $('#contactModal').on('show.bs.modal', function (e) {

        let $invoker = $(e.relatedTarget);

        let id = $invoker.data('id');

        loadContactToModal(id)
    })
})();
